module.exports = __webpack_public_path__ + "img/pentagon-bg.cae22d42.svg";